import { useEffect, useState } from 'react';
import axios from 'axios';

export const useIsOnline = (): boolean => {
  const [isOnline, setIsOnline] = useState<boolean>(true);

  function onOnline() {
    // Wait 15 seconds to allow network to reestablish
    setTimeout(async () => {
      try {
        await axios.get('/home/ping');
        console.log('Reconnected to network');
        setIsOnline(true);
      } catch {
        onOnline();
      }
    }, 15000);
  }

  async function onOffline() {
    try {
      await axios.get('/home/ping');
    } catch {
      console.log('Disconnected from network');
      setIsOnline(false);
    }
  }

  useEffect(() => {
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);

    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  return isOnline;
};
